import { mapDataSource, RawDataSource } from '~/Api/DataSource';
import Price from '~/utils/Price';

import { ReferencedProduct } from './ReferencedProduct';

export interface RawReferencedProduct {
	readonly id: string;
	readonly currentWholesalePrice: Price | null;
	readonly dataSource: RawDataSource;
}

export const mapReferencedProduct = (product: RawReferencedProduct) =>
	new ReferencedProduct(
		product.id,
		product.currentWholesalePrice !== null
			? new Price(product.currentWholesalePrice.value, product.currentWholesalePrice.currency)
			: null,
		mapDataSource(product.dataSource)
	);
